import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/boardList.module.scss';
//hooks
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트

export default function ProductList (props, ref) {
    const navigator = useNavigate();
    //hook
    const { axiosPostHandler } = useAxiosHook();
    const { setNumberHandler } = useComnHook();
    //store
    const { setMessage } = useComnStore();
    const { list, setList } = props;
    /* ==================== 쿠폰삭제 ==================== */
    const isLock = useRef(false);
    const couponDeactivationAPI = async(data) => {
        if(!window.confirm("데이터를 삭제한 후에는 다시 복구할 수 없습니다.\n삭제하시겠습니까?")) { return; }
        try {
            if (isLock.current) { return; }
            isLock.current = true;
            const DATA = { SEQ_NO: data.SEQ_NO, STATE: 4, };
            const result = await axiosPostHandler("siteCouponUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if(isOk){setMessage({type:1, label:`쿠폰 삭제가 완료되었습니다.`});setList(before => before.filter((item) => item.SEQ_NO !== data.SEQ_NO));return;}
            if(result.message === "ALREADY_ISSUED"){setMessage({type:2, label:`이미 회원에게 발급된 쿠폰은 비활성화할 수 없습니다.`});return;}
            setMessage({type:2, label:`쿠폰 삭제에 실패 하였습니다.`});

        } finally { isLock.current = false; }
    }
    /* ==================== 쿠폰삭제 ==================== */
    const [ toggle,setToggle ] = useState(null);//공지내용토글
    const couponUpdateHandler = async(item) => {
        const DATA = {SEQ_NO:item.SEQ_NO}
        const result = await axiosPostHandler("siteCouponUpdateCheckForAdmin.do", DATA);
        const isOk = result && result.message === "SUCCESS";
        if(!isOk){return;}
        navigator("reg",{state:{...item, TYPE:result.data.result}})
    }
    return ( 
        <>
        <Element tag={`div`} className={styles.boardListContainer}>
            <Element tag={`ul`}>
                {list?.length > 0 && list.map((item, i) =>
                    <Element key={item.SEQ_NO} tag={`li`}>
                        <Element tag={`div`} className={toggle === item ? styles.selected : null}>
                            <Element tag={`div`} className={styles.title}>
                                <Element tag={`div`}><Element tag={`h2`} style={{width:'25rem'}}>{item.ITEM_NAME}</Element></Element>
                                <Element tag={`div`} className={styles.btnArea}>
                                    <Button anyprop={(e) => couponDeactivationAPI(item)} class={"subtitle"} icon="fa-light fa-trash-can" label={"삭제하기"} ></Button>
                                    <Button anyprop={(e) => couponUpdateHandler(item)} class={"subtitle"} icon="fa-light fa-pen-to-square" label={"수정하기"} ></Button>
                                    <a onClick={(e) => setToggle(toggle === item ? {} : item)}><FontAwesomeIcon icon={["fa-light", toggle === item ? "fa-chevron-up": "fa-chevron-down"].join(" ")} /></a>
                                </Element>
                            </Element>
                            <Element tag={`div`} className={styles.info}>
                                <Element tag={`div`}><Element tag={`span`}>판매가격: {setNumberHandler(item.SALE_PRICE)} 원</Element></Element><Element tag={`hr`} />
                                <Element tag={`div`}><Element tag={`span`}>{item.PARTNER_NAME}</Element></Element>
                            </Element>
                        </Element>
                        {toggle === item ? 
                            <Element tag={`article`}>
                                <img height={100} src={process.env.REACT_APP_IMAGE_URL+item.IMG_SRC} />
                                <Element tag={`pre`}>할인율: {item.DISCOUNT_RATE}</Element>
                                <Element tag={`pre`}>설명: {item.DESCRIPTION}</Element>
                                <Element tag={`pre`}>기본 배송료: {item.BASE_FEE}</Element>
                            </Element>
                        : null}
                    </Element>
                )}
            </Element>
        </Element>
        </>
    )
}